module.exports = __webpack_public_path__ + "img/c2.5cee8ba9.png";